// ---------------------------------------------------------------------------
// NAV-FE-5 — the shell's search by number: the box's facts (no DOM).
//
// Over `GET /projects/{id}/search?q=` (docs/design/search.md §3). The server
// decides who sees what and the order (exact → prefix → contains); this file
// only groups the hits by family, keeps the server's order inside each group,
// and names the page each hit opens (search.md §2). Nothing here filters.
// ---------------------------------------------------------------------------

// The server's limits (search.md §1.2) and the box's pause before it reads.
export const SEARCH_MIN_CHARS = 2;
export const SEARCH_MAX_CHARS = 40;
export const SEARCH_DEBOUNCE_MS = 250;

// The server's family order (search.md §2).
export const KIND_ORDER = ['asset', 'itc', 'ncr', 'rfi', 'test_request', 'handover_inspection', 'punch_item'];

export const KIND_LABEL = {
  asset: 'Assets',
  itc: 'ITCs',
  ncr: 'NCRs',
  rfi: 'RFIs',
  test_request: 'Test requests',
  handover_inspection: 'Handover inspections',
  punch_item: 'Punch items',
};

/** The page a hit opens (search.md §2, the routes App.js declares); unknown kind → null. */
export const hitHref = (hit, projectId) => {
  const id = hit?.id;
  if (!id) return null;
  switch (hit.kind) {
    case 'asset': return `/assets/${id}`;
    case 'itc': return `/structured-itcs/${id}`;
    case 'ncr': return `/ncrs/${id}`;
    case 'rfi': return `/rfis/${id}`;
    case 'test_request': return `/projects/${projectId}/test-requests/${id}`;
    case 'handover_inspection': return `/projects/${projectId}/handover/inspections/${id}`;
    case 'punch_item': return `/projects/${projectId}/handover/punch/${id}`;
    default: return null;
  }
};

/** `[{kind, label, hits}]`: the families present, in KIND_ORDER; inside, the server's order. */
export const groupHits = (hits) => {
  const list = Array.isArray(hits) ? hits : [];
  return KIND_ORDER
    .map((kind) => ({ kind, label: KIND_LABEL[kind], hits: list.filter((h) => h?.kind === kind) }))
    .filter((g) => g.hits.length > 0);
};

/** The hits in the order they are drawn — the keyboard walks this list. */
export const flattenGroups = (groups) => (Array.isArray(groups) ? groups : []).flatMap((g) => g.hits);
